export function creationTime (ctime) {
  var timestamp = Date.parse(new Date());
  ctime = ctime.replace(/-/g, "/"); // 兼容ios
  var date = new Date(ctime);
  date = Date.parse(date);
  if (timestamp - date < 60 * 1000) {
    ctime = "刚刚";
  } else if (timestamp - date < 60 * 60 * 1000) {
    ctime = parseInt((timestamp - date) / (1000 * 60)) + "分钟前";
  } else if (timestamp - date < 24 * 60 * 60 * 1000) {
    ctime = parseInt((timestamp - date) / (60 * 60 * 1000)) + "小时前";
  } else if (timestamp - date < 365 * 24 * 60 * 60 * 1000) {
    ctime = ctime.slice(5);
    ctime = ctime.substring(0, ctime.length - 3);
  } else if (timestamp - date > 365 * 24 * 60 * 60 * 1000) {
    ctime = ctime.substring(0, ctime.length - 3);
  }
  ctime = ctime.replace(/\//g, "-");
  return ctime;
}
export function cTime (ctime) {
  var timestamp = Date.parse(new Date());
  ctime = ctime.replace(/-/g, "/"); // 兼容ios
  var date = new Date(ctime);
  date = Date.parse(date);
  if (timestamp - date < 60 * 1000) {
    ctime = "刚刚";
  } else if (timestamp - date < 60 * 60 * 1000) {
    ctime = parseInt((timestamp - date) / (1000 * 60)) + "分钟前";
  } else if (timestamp - date < 24 * 60 * 60 * 1000) {
    ctime = parseInt((timestamp - date) / (60 * 60 * 1000)) + "小时前";
  } else if (timestamp - date < 365 * 24 * 60 * 60 * 1000) {
    ctime = ctime.slice(5);
    ctime = ctime.substring(0, ctime.length - 3);
  } else if (timestamp - date > 365 * 24 * 60 * 60 * 1000) {
    ctime = ctime.substring(0, ctime.length - 3);
  }
  ctime = ctime.replace(/\//g, "-");
  return ctime;
}
export function c2Time (ctime) {
  if (!ctime) return;
  var timestamp = Date.parse(new Date());
  ctime = ctime.replace(/-/g, "/"); // 兼容ios
  var date = new Date(ctime);
  date = Date.parse(date);
  if (timestamp - date < 365 * 24 * 60 * 60 * 1000) {
    // ctime = ctime.slice(5);
    ctime = ctime.substring(0, ctime.length - 3);
  } else if (timestamp - date > 365 * 24 * 60 * 60 * 1000) {
    ctime = ctime.substring(0, ctime.length - 3);
  }
  ctime = ctime.replace(/\//g, ".");
  return ctime;
}
export function time (ctime) {
  ctime = ctime.replace(/-/g, "."); // 兼容ios
  return ctime;
}
export function getNowFormatDate () {
  var date = new Date();
  var seperator1 = "-";
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var hh =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var mm = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  var currentdate =
    date.getFullYear() +
    seperator1 +
    month +
    seperator1 +
    strDate +
    " " +
    hh +
    mm;
  return currentdate;
}
export function getFormatDate (date) {
  var seperator1 = "-";
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate =
    date.getFullYear() + seperator1 + month + seperator1 + strDate;
  return currentdate;
}
export function getDay (day) {
  var today = new Date();

  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;

  today.setTime(targetday_milliseconds); // 注意，这行是关键代码
  var tYear = today.getFullYear();

  var tMonth = today.getMonth();

  var tDate = today.getDate();

  tMonth = doHandleMonth(tMonth + 1);

  tDate = doHandleMonth(tDate);

  return tYear + "-" + tMonth + "-" + tDate;
}
function doHandleMonth (month) {
  var m = month;
  if (month.toString().length == 1) {
    m = "0" + month;
  }
  return m;
}

export function times (data) {
  var date = new Date(data);
  var YY = date.getFullYear() + "-";
  var MM =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var DD = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  var hh =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var mm =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":";
  var ss = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return YY + MM + DD + hh + mm + ss;
}
export function getNewDay (dateTemp, days) {
  //			var dateTemp = dateTemp.split("-");
  //			alert(dateTemp);
  var nDate = new Date(dateTemp); // 转换为MM-DD-YYYY格式
  // alert(nDate);
  var millSeconds = Math.abs(nDate) + days * 24 * 60 * 60 * 1000;
  // alert(millSeconds);
  var rDate = new Date(millSeconds);
  var year = rDate.getFullYear();
  var month = rDate.getMonth() + 1;
  if (month < 10) month = "0" + month;
  var date = rDate.getDate();
  if (date < 10) date = "0" + date;
  return year + "-" + month + "-" + date;
}

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal (path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}
export function timestampToTime (timestamp) {
  var date = new Date(timestamp); // 时间戳转换成Date对象
  var hours = date.getHours().toString().padStart(2, "0"); // 获取小时部分，并补零
  var minutes = date.getMinutes().toString().padStart(2, "0"); // 获取分钟部分，并补零
  return hours + ":" + minutes; // 返回时分格式
}
export function convertDateFormat (dateString) {
  const dateParts = dateString.match(/(\d{4})(\d{2})(\d{2})/);
  if (dateParts) {
    const year = dateParts[1];
    const month = dateParts[2];
    const day = dateParts[3];
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }
}
export function getWeekday (date) {
  const weekdays = [
    "星期日",
    "星期一",
    "星期二",
    "星期三",
    "星期四",
    "星期五",
    "星期六"
  ];
  let week = '';
  const weekday = weekdays[new Date(date).getDay()];
  switch (weekday) {
    case '星期一':
      week = '周一';
      break;
    case '星期二':
      week = '周二';
      break;
    case '星期三':
      week = '周三';
      break;
    case '星期四':
      week = '周四';
      break;
    case '星期五':
      week = '周五';
      break;
    case '星期六':
      week = '周六';
      break;
    case '星期日':
      week = '周日';
      break;
    default:
      break;
  }
  return week;
}
export function getWeekday1 (date) {
  const weekdays = [
    "星期日",
    "星期一",
    "星期二",
    "星期三",
    "星期四",
    "星期五",
    "星期六"
  ];
  const weekday = new Date(date).getDay();
  return weekdays[weekday];
}
// 将日期格式 YYYY-MM-DD 转换为 YYYYMMDD
export function convertDate (dateString) {
  const date = new Date(dateString);
  // if (isNaN(date.getTime())) {
  //   throw new Error("Invalid date string");
  // }
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2); // 月份是从0开始的
  const day = ("0" + date.getDate()).slice(-2);
  return year + month + day;
}

// 将日期格式 YYYYMMDD 转换为 YYYY-MM-DD
export function formatDate (dateString) {
  return `${dateString.slice(0, 4)}-${dateString.slice(4, 6)}-${dateString.slice(6, 8)} ${dateString.slice(8, 10)}:${dateString.slice(10, 12)}`;
}
// 将日期格式 YYYYMMDDHHmm 转换为 HH:mm
export function formatDateHHMM (dateString) {
  if (dateString) {
    dateString = dateString + "";
    return `${dateString.slice(8, 10)}:${dateString.slice(10, 12)}`;
  } else {
    return "--";
  }
}

// 获取日期 MMDD
export function getMMDD (data) {
  var date = new Date(data);
  var MM =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var DD = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  return MM + DD;
}
// 将日期格式 YYYYMMDD
export function getYYYYMMDD (data) {
  var today = new Date(data);
  var tYear = today.getFullYear();

  var tMonth = today.getMonth();

  var tDate = today.getDate();

  tMonth = doHandleMonth(tMonth + 1);

  tDate = doHandleMonth(tDate);

  return tYear + "-" + tMonth + "-" + tDate;
}

// 将毫秒转换成日期格式YYYYMMDD
export function msecToYYYYMMDD (ms) {
  if (!ms) return "--";
  const date = new Date(ms);
  const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  return formattedDate;
}

// 将毫秒
export function msecToYYYYMMDDhhmmss (ms) {
  if (!ms) return "--";
  const date = new Date(ms);
  const formattedDate = msecToYYYYMMDD(ms);
  const formattedDateTime = `${formattedDate} ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;
  return formattedDateTime;
}
// 把秒格式化时间为 MM:SS
export function ssToMMSS (seconds) {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
}

// 把秒格式化时间为 HH:MM:SS
export function ssToHHMMSS (seconds) {
  if (!seconds && seconds !== 0) return "--";
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  return `${hrs.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
}

// 把时间戳格式化为 YYYY-MM-DD hh:mm
export function formatYYYYMMDDhhmm (timestamp) {
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

/**
 * 指定为中国时区(为了解决国外的时差导致的股票的不更新的问题)
 * @returns
 */
export function chinaTimeToString () {
  const options = {
    timeZone: "Asia/Shanghai",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  };

  const chinaTimeString = new Date().toLocaleString("zh-CN", options);
  return chinaTimeString || new Date().toLocaleString();
}

export function formatChinaTime (timestamp) {
  const date = new Date(timestamp);
  const fDate = date.toLocaleString("zh-CN", {
    timeZone: "Asia/Shanghai",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  });

  return fDate;
}



// 获取当前是否是A股交易时间
export const isStockMarketOpen = (keys, values) => {
  // 获取当前日期和时间
  const now = new Date();
  // 获取当前的小时和分钟
  const hours = now.getHours();
  const minutes = now.getMinutes();
  // 获取当前是周几（0代表周日，1代表周一，以此类推）
  const dayOfWeek = now.getDay();
  // 计算当前总分钟数
  const currentMinutes = hours * 60 + minutes;
  // 定义交易时间段
  const startMinutes = 9 * 60 + 15; // 9:15
  const endMinutes = 15 * 60 + 1; // 15:01
  // 检查是否为工作日 (周一至周五) 且在交易时间内
  return (dayOfWeek >= 1 && dayOfWeek <= 5) &&
         (currentMinutes >= startMinutes && currentMinutes < endMinutes);
};

/**
 * 获取交易日期
 * @param {number} type - 类型：1=获取当前交易日，2=获取上一个交易日
 * @param {Date|string} date - 指定日期，默认为当前日期
 * @param {string} format - 返回格式，'YYYY-MM-DD'、'YYYY-MM' 或 'MM-DD'，默认为 'YYYY-MM-DD'
 * @returns {string} 交易日期
 */
export function getTradingDate(type = 2, date = new Date(), format = 'YYYY-MM-DD') {
  // 如果传入的是字符串，转换为Date对象
  if (typeof date === 'string') {
    date = new Date(date);
  }

  // 确保是有效的日期
  if (isNaN(date.getTime())) {
    throw new Error('Invalid date provided');
  }

  // 验证type参数
  if (type !== 1 && type !== 2) {
    throw new Error('Type must be 1 (current trading day) or 2 (previous trading day)');
  }

  const currentDate = new Date(date);

  if (type === 1) {
    // 获取当前交易日：如果当前是周末，向前查找最近的交易日
    while (true) {
      const dayOfWeek = currentDate.getDay();

      // 如果是工作日（周一到周五），则找到交易日
      if (dayOfWeek >= 1 && dayOfWeek <= 5) {
        // 检查是否是节假日（这里可以扩展添加具体的节假日判断）
        // 目前简单处理，只排除周末
        break;
      }

      // 向前推一天
      currentDate.setDate(currentDate.getDate() - 1);
    }
  } else if (type === 2) {
    // 获取上一个交易日：先向前推一天，然后查找最近的交易日
    currentDate.setDate(currentDate.getDate() - 1);

    // 向前查找最近的交易日（周一到周五）
    while (true) {
      const dayOfWeek = currentDate.getDay();

      // 如果是工作日（周一到周五），则找到交易日
      if (dayOfWeek >= 1 && dayOfWeek <= 5) {
        // 检查是否是节假日（这里可以扩展添加具体的节假日判断）
        // 目前简单处理，只排除周末
        break;
      }

      // 向前推一天
      currentDate.setDate(currentDate.getDate() - 1);
    }
  }

  // 格式化日期
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');

  if (format === 'YYYY-MM') {
    return `${year}-${month}`;
  } else if (format === 'MM-DD') {
    return `${month}-${day}`;
  } else {
    return `${year}-${month}-${day}`;
  }
}
